import { Link } from "@tanstack/react-router";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { FISHING_GUIDE_PATH, MAPS_URL, ROOMS_PATH, WINTER_TEXANS_GUIDE_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";


export function FalconZapataSection() {
  const photo = PHOTOS.cabinRow;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-24 sm:py-28 lg:py-36"
      aria-labelledby="falcon-zapata-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(105deg,oklch(0.259_0.042_163.6/0.94)_0%,oklch(0.259_0.042_163.6/0.78)_48%,oklch(0.259_0.042_163.6/0.55)_100%)]"
        aria-hidden="true"
      />

      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-2xl text-cream">
          <p className="eyebrow text-sand">Explore the Area</p>
          <h2
            id="falcon-zapata-title"
            className="mt-5 text-balance font-display text-3xl leading-[1.1] sm:text-4xl lg:text-[3rem]"
          >
            Fishing, Boating and South Texas Experiences
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-cream/85 sm:text-lg">
            <p>
              Amigo Inn &amp; RV Park is located in Zapata near Falcon Lake and public boat access.
              The area gives guests opportunities to enjoy fishing, boating, South Texas scenery,
              local restaurants, and the community&apos;s distinctive blend of Texan and Mexican
              culture.
            </p>
            <p>
              Whether you are preparing for a morning on the water or exploring Zapata, Amigo Inn
              provides a comfortable place to return to at the end of the day.
            </p>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4">
            <Link
              to={routeTo(ROOMS_PATH)}
              className="link-underline text-sm font-semibold text-cream"
            >
              Explore Rooms and RV Sites <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            <Link
              to={routeTo(FISHING_GUIDE_PATH)}
              className="link-underline text-sm font-semibold text-cream"
            >
              Falcon Lake Bass Fishing Guide <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            <Link
              to={routeTo(WINTER_TEXANS_GUIDE_PATH)}
              className="link-underline text-sm font-semibold text-cream"
            >
              Winter Texan Guide <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-sm font-semibold text-sand"
            >
              Get Directions <ArrowUpRight className="size-4" aria-hidden="true" />
            </a>
          </div>

        </Reveal>
      </div>
    </section>
  );
}
